'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    OverflowContext: function() {
        return OverflowContext;
    },
    useOverflowContext: function() {
        return useOverflowContext;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const OverflowContext = (0, _reactcontextselector.createContext)(undefined);
const overflowContextDefaultValue = {
    itemVisibility: {},
    groupVisibility: {},
    hasOverflow: false,
    registerItem: ()=>()=>null,
    updateOverflow: ()=>null,
    registerOverflowMenu: ()=>()=>null,
    registerDivider: ()=>()=>null
};
const useOverflowContext = (selector)=>(0, _reactcontextselector.useContextSelector)(OverflowContext, (ctx = overflowContextDefaultValue)=>selector(ctx));
